<template>
  <div>
    <BaseModal small v-model="modalOpen" :title="$t('exports.availableDownloads')">
      <div class="export-content">
        <LoadingSpinner v-if="loading" />
        <template v-else>
          <div v-if="exports.length < 1" class="export-info">
            <p class="alert alert-info">{{ $t('exports.noDownloads') }}</p>
          </div>
          <div v-else class="export-list">
            <ListItem
              v-for="ex in exports"
              :key="ex.uuid"
              :class="{ 'list-item--low-profile': ex.downloaded }"
              :hasDetails="false"
              :opensOnLeft="false"
              :actions="[{ iconName: 'download', clickEvent: () => downloadExport(ex) }]"
            >
              <template v-slot:row-cols>
                <div class="main-row__col--main">
                  {{ ex.name }}
                </div>
                <div class="main-row__col main-row__col--small">
                  {{ ex.company_name }}
                </div>
                <div class="main-row__col main-row__col--small">
                  {{ formattedFromDateTime(ex.created_at) }}
                </div>
              </template>
            </ListItem>
          </div>
        </template>
      </div>
    </BaseModal>
    <a @click="modalOpen = true" :tooltip="$t('exports.availableDownloads')" flow="down">
      <span class="material-icons">save</span>
      <span class="nav-small-txt">
        <LoadingSpinner small v-if="loading" />
        <template v-else> {{ newExportCount }}</template>
      </span>
    </a>
  </div>
</template>

<script>
import { createConsumer } from '@rails/actioncable'
import Vue from 'vue'

import BaseModal from '@/components/BaseModal'
import ListItem from '@/components/ListItems/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import dateUtils from '@/components/mixins/dateUtils'

import exportsApi from '@/api/exports'

export default {
  components: { BaseModal, ListItem, LoadingSpinner },
  mixins: [dateUtils],
  data: () => ({
    modalOpen: false,
    loading: true,
    exports: [],
    consumer: null,
    subscription: null,
  }),
  methods: {
    async downloadExport(ex) {
      Vue.set(ex, 'downloaded', true)
      window.open(ex.file_url, '_self')
      await exportsApi.update(ex.uuid, { downloaded: true })
    },
    async loadExports() {
      this.exports = await exportsApi.getAll()
      this.loading = false
    },
  },
  computed: {
    newExportCount() {
      return this.exports.filter(ex => !ex.downloaded).length
    },
  },
  mounted() {
    this.loadExports()
    this.consumer = createConsumer(`${process.env.VUE_APP_BASE_APP}/cable`.replace('http', 'ws'))

    const self = this
    this.subscription = this.consumer.subscriptions.create(
      { channel: 'ExportsChannel' },
      {
        received(e) {
          self.exports.unshift(e)
        },
      },
    )
  },
  unmounted() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  },
}
</script>

<style scoped>
.export-content {
  .export-info {
    padding: 1rem 1.5rem;
    background-color: #fff;
  }
  .export-list {
    padding: 1rem 1.5rem;
    background-color: #f1f1f1;
    border-radius: var(--border-radius-m);
  }
}
</style>
